// import 'babel-polyfill';
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import merge from 'webpack-merge';

Vue.prototype.$merge = merge
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

function qimo() {
    var kf = document.createElement('script');
    kf.src = 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=910920a0-1a5c-11eb-a51a-1be58fb800cd&autoShow=false&language=ZHCN';
    document.getElementsByTagName('body')[0].appendChild(kf).setAttribute("async", "async");

}
// qimo();
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js